import { IAuthenticator } from "@/domain/repositories/Auth";

export class BasicAuthenticator implements IAuthenticator {
  type: string;

  constructor() {
    this.type = "basic";
  }

  async authenticate(credentials?: { username: string; password: string }) {
    if (!credentials) {
      throw new Error("Missing credentials");
    }

    return { token: "token" };
  }

  async deauthenticate() {
    return;
  }
}
